import { inject, Injectable } from '@angular/core';
import type { TimeSeriesInput } from '@clean-code/models';
import { TimeSeriesIndexSummary } from '@clean-code/models';
import { Observable } from 'rxjs';
import { MarketDashboardDetailsDataService } from '../infrastructure/dashboard-details.data.service';

@Injectable({ providedIn: 'root' })
export class DashboardDetailsFacade {
  private service = inject(MarketDashboardDetailsDataService);

  public getIndexDetails$(
    symbol: TimeSeriesInput,
    date: Date,
  ): Observable<TimeSeriesIndexSummary> {
    return this.service.getIndexDetails$(symbol, date);
  }

  public getCompactIndexDetails$(symbol: TimeSeriesInput, date: Date) {
    return this.service.getCompactIndexDetails$(symbol, date);
  }
}
